import {
  APPLIANCE_FILTER_FETCH_STARTED,
  APPLIANCE_FILTER_FETCH_SUCCEEDED,
  APPLIANCE_FILTER_FETCH_FAILED,
  APPLIANCE_FILTER_SET_FILTER,
  APPLIANCE_FILTER_CLEAR,
  APPLIANCE_FILTER_SELECTED_DATA_FETCH_SUCCEEDED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  appliances: [],
  warehouses: [],
  projects: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: ['label'],
  pages: 0,
  filter: [],
  selectedFilter: [],
  filterBy: ['label', 'warehouse', 'project']
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APPLIANCE_FILTER_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case APPLIANCE_FILTER_FETCH_SUCCEEDED:
      const { appliances, projects, warehouses = [] } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        appliances,
        warehouses,
        projects,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case APPLIANCE_FILTER_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], error: action.error };
    case APPLIANCE_FILTER_SET_FILTER:
      return { ...state, filter: action.payload };
    case APPLIANCE_FILTER_SELECTED_DATA_FETCH_SUCCEEDED:
      return {
        ...state,
        selectedFilter: action.payload
      };
    case APPLIANCE_FILTER_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
